import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export function BeforeAfter() {
  const scenes = [{
    title: 'Tu Mañana',
    before: ['Te despertás cansada. Necesitás 3 alarmas.', 'Te arrastrás a la cocina. El café es obligatorio.', 'Piel opaca, ojeras, hinchazón facial.'],
    after: ['Te despertás naturalmente, descansada.', 'Piel luminosa. Menos hinchazón. Ojos despiertos.', 'Energía REAL (no cafeína artificial).']
  }, {
    title: 'Tu Tarde',
    before: ['3 PM. Necesitás tu tercer café.', 'Te sentís pesada, mental y físicamente.', 'Querés dormir una siesta en tu escritorio.'],
    after: ['3 PM. Todavía tenés energía sostenida.', 'Claridad mental. Cuerpo liviano.', 'No necesitás estimulantes. Tu cuerpo funciona.']
  }, {
    title: 'Tu Noche',
    before: ['10 PM. Cansada pero no podés dormir.', 'Tu mente no para. Das vueltas en la cama.', 'A las 3 AM te despertás y no volvés a dormir.'],
    after: ['10 PM. Tu cuerpo está listo para descansar.', 'Dormís 7-8 horas profundas, sin interrupciones.', 'Te despertás regenerada. Lista para el día.']
  }, {
    title: 'Tu Reflejo',
    before: ['Te mirás al espejo y no te reconocés.', "'¿Cuándo pasó esto? ¿Cuándo me vi tan cansada?'", 'Evitás fotos. No querés verte.'],
    after: ['Te mirás al espejo y te gustás.', 'Piel más firme. Luminosidad real.', "No sos 'la de 25', pero te sentís VIVA."]
  }];
  return <Section bg="white" data-id="element-82">
      <div className="text-center mb-20" data-id="element-83">
        <p className="text-xs font-medium tracking-[0.2em] text-gold uppercase mb-6" data-id="element-84">
          La Transformación
        </p>
        <h2 className="text-4xl md:text-6xl font-serif text-charcoal mb-6" data-id="element-85">
          ¿Cómo se siente envejecer con el <br className="hidden md:block" data-id="element-86" />
          <span className="italic text-olive" data-id="element-87">Método Wellaging 360°?</span>
        </h2>
        <p className="text-xl text-charcoal-light font-light" data-id="element-88">
          Imaginá tu vida en 30 días...
        </p>
      </div>

      <div className="space-y-8 max-w-5xl mx-auto" data-id="element-89">
        {scenes.map((scene, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="grid md:grid-cols-[200px_1fr_1fr] gap-6 md:gap-0 bg-cream-light rounded-2xl overflow-hidden border border-gold/10" data-id="element-90">
            <div className="p-6 md:p-8 flex items-center justify-center bg-cream-dark/50 md:border-r border-gold/10" data-id="element-91">
              <h3 className="font-serif italic text-2xl text-charcoal text-center" data-id="element-92">
                {scene.title}
              </h3>
            </div>

            {/* Before */}
            <div className="p-6 md:p-8 md:border-r border-gold/10" data-id="element-93">
              <p className="text-xs font-medium tracking-widest uppercase text-charcoal/40 mb-6" data-id="element-94">
                Antiaging Tradicional
              </p>
              <ul className="space-y-4" data-id="element-95">
                {scene.before.map((item, i) => <li key={i} className="text-charcoal-light/70 font-light text-sm flex items-start gap-3" data-id="element-96">
                    <span className="text-charcoal/20 mt-0.5" data-id="element-97">—</span>
                    <span data-id="element-98">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="p-6 md:p-8 bg-olive/5 relative overflow-hidden" data-id="element-99">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-full blur-2xl" data-id="element-100" />
              <p className="text-xs font-medium tracking-widest uppercase text-olive mb-6 relative z-10" data-id="element-101">
                Método Wellaging
              </p>
              <ul className="space-y-4 relative z-10" data-id="element-102">
                {scene.after.map((item, i) => <li key={i} className="text-charcoal font-medium text-sm flex items-start gap-3" data-id="element-103">
                    <span className="text-gold mt-0.5" data-id="element-104">+</span>
                    <span data-id="element-105">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>)}
      </div>

      <div className="mt-24 text-center max-w-3xl mx-auto" data-id="element-106">
        <p className="text-2xl font-serif italic text-charcoal mb-12" data-id="element-107">
          Esa es la diferencia entre envejecer en piloto automático o envejecer
          con intención.
        </p>

        <Button className="text-xl" subtext="Solo $17.990 · Acceso Inmediato" data-id="element-108">
          Quiero sentirme así en 30 días
        </Button>
      </div>
    </Section>;
}